import React from "react";
import { Form, Grid, Portal } from "semantic-ui-react";

import { Controller } from "react-hook-form";
import { Button } from "dyl-components";
import { Link } from "react-router-dom";

import "./PermissionRoleForm.scss";
import SettingsFooter from "dyl-components/molecules/SettingsFooter";
import useWidthListener from "shared/SettingsFooter/useWidthListener";
import useWindowWidth from "shared/SettingsFooter/useWindowWidth";
import { MathUtils } from "utils";
import { useConfirm } from "shared/confirmation/useConfirm";
import CustomPrompt from "shared/confirmation/CustomPrompt";
import ConfirmModal from "shared/confirmation/ConfirmModal";

const PermissionRolesForm = ({
    isSaving,
    onSave,
    permissionConfigs,
    type,
    control,
    getValues,
    setError,
    isValid,
    isDirty,
    uniqueNameValidate,
}) => {
    const width = useWidthListener("settingsSidebar");
    const windowWidth = useWindowWidth();
    const { isConfirmed } = useConfirm();

    const viewOnly = type === "view";

    const onSetError = (name, { type, message }) => {
        setError(name, { type, message });
    };

    CustomPrompt(
        null,
        isDirty,
        isConfirmed,
        "Changes not saved",
        "Are you sure you want to exit?",
    );
    return (
        <>
            <ConfirmModal />
            <Grid
                className={
                    (type === "view" ? "OnlyViewPermissions" : null) +
                    " PermissionProfile__container"
                }
            >
                <Grid.Row>
                    <Grid.Column>
                        <Form loading={isSaving} size="small">
                            <Controller
                                name="name"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <Form.Input
                                        width={8}
                                        {...field}
                                        onBlur={uniqueNameValidate}
                                        disabled={viewOnly}
                                        label={"Permission Profile Name"}
                                        error={error && error.message}
                                        required
                                        autoFocus
                                    />
                                )}
                            />

                            <Controller
                                name="description"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <Form.TextArea
                                        width={8}
                                        {...field}
                                        label={"Description"}
                                        disabled={viewOnly}
                                        error={error && error.message}
                                        required
                                    />
                                )}
                            />
                            {permissionConfigs}
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Portal open>
                <SettingsFooter
                    style={{
                        width: MathUtils.calculatePercentage(
                            windowWidth,
                            windowWidth - width,
                        ),
                    }}
                    className={`Webform__menu`}
                    rightOptions={[
                        <Button
                            as={Link}
                            to="/settings/permission-profile"
                            status={"cancel"}
                            basic
                        >
                            Cancel
                        </Button>,
                        type !== "view" && (
                            <Form.Group>
                                <Button
                                    disabled={!isValid || !isDirty || isSaving}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onSave(getValues(), onSetError);
                                    }}
                                    primary
                                    loading={isSaving}
                                >
                                    Save
                                </Button>
                            </Form.Group>
                        ),
                    ]}
                />
            </Portal>
        </>
    );
};

export default PermissionRolesForm;
